import { OverviewCard }                               from "components/OverviewCard";
import { Page }                                       from "components/Page";
import { DvcPage, PageList } from "navigation/DvcPage";
import { RouterMap }         from "navigation/RouterMap";
import { Glob, useLoc } from "functions/Language";
import { RType, SupportedDevices } from "functions/networking/NetTypes";
import { POnline }    from "pages/Details/Online";
import { PHarmonics } from "pages/Details/Harmonics";
import { PVector }    from "pages/Details/Vector";
import { Energy }     from "pages/Details/Energy";
import { IOState }    from "pages/Details/IOState";
import { PStages }    from "pages/Details/GCRStages";
import { MeasurementsTable } from "components/MeasurementsTable";
import { FC } from "react";
import { PAlarms } from "./GCRAlarms";


const route = RouterMap.measurements;

const Overview: FC<{
  data: RType<"Online_Short", SupportedDevices>,
}> = (props) => {
	const loc = useLoc(glob);

	return <OverviewCard title={loc.title} href={route}>
		<MeasurementsTable data={props.data} />
	</OverviewCard>
}


const MeasurementPages : DvcPage[] = [
  POnline,
  PHarmonics,
  PVector,
  Energy,
  IOState,
  PStages,
  PAlarms,
];

const Detail : FC = () => {
  const loc = useLoc(glob);

  return <Page title={loc.title}>
		<PageList pages={MeasurementPages} routerDirection="forward" />
  </Page>
}


const glob = Glob({
	en: {
		title: "Online values",
	},
	cs: {
		title: "Okamžité hodnoty",
	},
	pg: {
		title: "Valores on-line",
	},
	es: {
		title: "Valores on-line",
	},
} as const);


export const Measurements = {
	Overview,
}

export const PMeasurements : DvcPage = {
  page: Detail,
  path: route,
  title: glob
}
